import request from '@/axios/index.js'
// 建档申请
export function bankBuildingApply(data,loading) {
    return request.axios({
        url: '/bankBuilding/bankBuildingApply',
        data: data,
        loading:loading
    })
}
// 建档列表
export function bankBuildingList(data,loading) {
  return request.axios({
      url: '/bankBuilding/bankBuildingList',
      data: data,
      loading:loading
  })
}



// WEBPACK FOOTER //
// ./src/api/bank.js